import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '@shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { FormWidgetTenantRelationComponent } from './form-widget-tenant-relation.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { BcmPipesModule } from '@modules/bcm/@shared/pipes/pipes.module';
import { ChipListInputModule } from '@sharedComponents/form/chip-list-input/chip-list-input.module';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DateTimeInputModule } from '@sharedComponents/form/date-time-input/date-time-input.module';
import { TranslationModule } from '@core/translation/translation.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [FormWidgetTenantRelationComponent],
    imports: [

        FuseSharedModule,
        SharedModule,

        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        BcmPipesModule,
        ChipListInputModule,
        MatButtonToggleModule,
        DateTimeInputModule,
        TranslationModule,
        MatTooltipModule,
    ],
    exports: [FormWidgetTenantRelationComponent]
})
export class FormWidgetTenantRelationModule {
    
}
